import { Redirect } from 'react-router-dom';

import { useLoggedInUserRoles } from '~/components/Auth';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';
import { RedirectToPortalContinue } from '~/scenes/PortalViews/components/RedirectToPortalContinue';
import { isMobileBrowser, redirectToApplicationConsole } from '~/utils/helper';

export const RedirectAuthenticatedLogin = () => {
  const loggedInUserRoles = useLoggedInUserRoles();
  const isSuperUser = loggedInUserRoles.includes('ADMIN');

  if (isSuperUser) {
    redirectToApplicationConsole('Login process detected Super User account');
    return <LoadingView />;
  }

  if (isMobileBrowser()) {
    return <Redirect to={'/mobile'} />;
  }

  return <RedirectToPortalContinue />;
};
